import { atom } from 'jotai';
import type { ImageFile } from '@/types/bulkPhoto';

/**
 * Atom for storing files staged for bulk photo upload.
 * Used only on /upload page during file selection.
 * Should be cleared after batch creation.
 */
export const stagedFilesAtom = atom<ImageFile[]>([]);

/**
 * Atom for storing the current batch ID during upload process.
 * Used to track batch status across routes and after page refresh.
 */
export const currentBatchIdAtom = atom<string | null>(null);

/**
 * Atom for controlling duplicate files modal visibility.
 */
export const showDuplicateFilesModalAtom = atom<boolean>(false);

/**
 * Atom for storing duplicate file count to display in modal.
 */
export const duplicateFilesCountAtom = atom<number>(0);

/**
 * Atom for storing the callback to execute when user confirms overwrite.
 * Called when user clicks "Overwrite files" in the DuplicateFilesModal.
 */
export const onDuplicateFilesConfirmAtom = atom<(() => void) | null>(null);

/**
 * Atom for controlling cancel upload confirmation modal visibility.
 * Shows when user clicks "X" button during active upload to confirm cancellation.
 */
export const showCancelUploadModalAtom = atom<boolean>(false);

/**
 * Atom for storing the callback to execute when user confirms upload cancellation.
 * Called when user clicks "Discard Upload" in the CancelUploadModal.
 */
export const onCancelUploadConfirmAtom = atom<(() => void) | null>(null);

/**
 * Atom for storing the callback to execute when user dismisses the cancel modal.
 * Called when user clicks "Continue" in the CancelUploadModal (typically to resume upload).
 */
export const onCancelUploadDismissAtom = atom<(() => void) | null>(null);
